import { apiClient } from 'api/client/apiClient';
import { ApplicationDTO } from '../types';
import { API_URLS } from '../consts';

export const getApplication = async (applicationId: string) => {
  const result = await apiClient.get<ApplicationDTO>(`${API_URLS.Applications}/applications/${applicationId}`);

  return result.data;
};
